import * as React from 'react';
import '../../../../../Image/index.js';
import { useSelectionListItemContext } from '../../hooks/useSelectionListItemContext.js';
import { Image as ImageMemoized } from '../../../../../Image/Image.js';

var SelectionListItemImage = /*#__PURE__*/React.memo(function (props) {
  var src = props.src;
  var _useSelectionListItem = useSelectionListItemContext(),
    isDisabled = _useSelectionListItem.isDisabled;
  return /*#__PURE__*/React.createElement(ImageMemoized.Decorative, {
    src: src,
    loading: "lazy",
    disabled: isDisabled,
    responsive: "manual",
    width: "24px",
    height: "24px",
    objectFit: "cover",
    requestWidth: 24,
    borderRadius: "4"
  });
});

export { SelectionListItemImage };
//# sourceMappingURL=SelectionListItemImage.js.map
